/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { ButtonHTMLAttributes, FC } from "react";

import { ComponentBaseProps } from "~/types";

const Clickable: FC<ComponentBaseProps & ButtonHTMLAttributes<HTMLButtonElement>> = ({ children, ...rest }) => {
  return (
    <button
      style={{
        padding: 0,
        margin: 0,
        outline: "none",
        border: "none",
        background: "none",
        width: "100%",
        height: "48px",
        cursor: "pointer",
        textAlign: "unset",
      }}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Clickable;
